var infoBarMessageCreatorsMap = {};
export default infoBarMessageCreatorsMap;
//# sourceMappingURL=infoBarMessageCreatorsMap.js.map